<template>
  <main class="terrain-access">
    <section class="terrain-access__card">
      <p class="terrain-access__eyebrow">Acceso controlado</p>
      <h1>Responder campaña de terreno</h1>
      <p class="terrain-access__lead">Ingresá el correo que recibió la invitación y la key incluida en el mensaje.</p>
      <form @submit.prevent="continueToCampaign">
        <label class="terrain-access__field">Correo electrónico
          <input v-model.trim="email" type="email" autocomplete="email" required :disabled="loading">
        </label>
        <label class="terrain-access__field">Key de acceso
          <input v-model.trim="key" type="text" autocomplete="one-time-code" placeholder="XXXX-XXXX-XXXX" maxlength="14" required :disabled="loading">
        </label>
        <p v-if="errorMessage" class="terrain-access__error" role="alert">{{ errorMessage }}</p>
        <button type="submit" class="terrain-access__submit" :disabled="loading">{{ loading ? 'Validando…' : 'Continuar' }}</button>
      </form>
    </section>
  </main>
</template>

<script>
import { createTerrainApi } from '../../services/terrain/api.js';
export default {
  name: 'TerrainControlledAccess',
  data: () => ({ email: '', key: '', loading: false, errorMessage: '' }),
  computed: { terrainApi() { return createTerrainApi(this.$http, this.$store.getters.backendurl); } },
  created() { this.tryExistingSession(); },
  methods: {
    async tryExistingSession() { try { const response = await this.terrainApi.resolveControlledForSession(this.$route.params.recipientAccessId); this.goToCampaign(response.data); } catch (_) { /* Se muestran correo y key como fallback. */ } },
    goToCampaign(data) { this.$router.replace({ name: data.prefill ? 'terrain-prefill-inbox' : 'terrain-campaign-form', params: { campaignId: data.campaignId } }); },
    async continueToCampaign() {
      this.loading = true; this.errorMessage = '';
      try {
        const response = await this.terrainApi.createControlledSession(this.$route.params.recipientAccessId, this.email, this.key.toUpperCase());
        this.goToCampaign(response.data);
      } catch (_) { this.errorMessage = 'Las credenciales no son válidas o la campaña no está disponible.'; }
      finally { this.loading = false; }
    },
  },
};
</script>

<style scoped lang="scss">
.terrain-access { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: var(--terrain-space-xl); background: var(--color-white); }

.terrain-access__card {
  width: 100%;
  max-width: 420px;

  h1 { color: var(--color-navy); font-size: var(--terrain-font-heading); margin: 0 0 var(--terrain-space-sm); }
}

.terrain-access__eyebrow { color: var(--color-orange); font-weight: 700; text-transform: uppercase; font-size: var(--terrain-font-caption); margin: 0 0 var(--terrain-space-xs); }
.terrain-access__lead { color: var(--color-graphite); margin: 0 0 var(--terrain-space-lg); }

.terrain-access__field {
  display: grid;
  gap: var(--terrain-space-xs);
  color: var(--color-navy);
  font-weight: 600;
  font-size: var(--terrain-font-caption);
  margin-bottom: var(--terrain-space-md);

  input {
    font: inherit;
    font-weight: 400;
    color: var(--color-graphite);
    padding: var(--terrain-space-sm) var(--terrain-space-md);
    border: 1px solid var(--color-line);
    border-radius: var(--terrain-radius-md);
    transition: border-color var(--terrain-transition), box-shadow var(--terrain-transition);

    &:hover { border-color: var(--color-steel); }
    &:focus { outline: none; border-color: var(--color-steel); box-shadow: var(--terrain-shadow-sm); }
  }
}

.terrain-access__error {
  margin: 0 0 var(--terrain-space-md);
  padding: var(--terrain-space-sm) var(--terrain-space-md);
  background: var(--terrain-color-danger-light);
  color: var(--color-danger);
  border-radius: var(--terrain-radius-sm);
  font-size: var(--terrain-font-caption);
}

.terrain-access__submit {
  width: 100%;
  border: 0;
  border-radius: var(--terrain-radius-xl);
  background: var(--color-navy);
  color: var(--color-white);
  font: inherit;
  font-weight: 600;
  padding: var(--terrain-space-sm) var(--terrain-space-lg);
  cursor: pointer;
  transition: background-color var(--terrain-transition);

  &:hover:not(:disabled) { background: var(--color-steel); }
  &:disabled { background: var(--color-ghost); cursor: not-allowed; }
}
</style>
